import { render } from "./TicketsGameShow.vue?vue&type=template&id=5992a75d&ts=true&lang=pug"
import script from "./TicketsGameShow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketsGameShow.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__